import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from "../../common/elements";

class PaymentPage extends Component {
    render() {

        const { paymentUrl, firstLoginToBundles } = this.props;

        if ( !paymentUrl ) return <Loader  />;

        return (
            <div className="container-fluid">
                <hr/>
                <div className="basket-body">
                    <div className={ `margin-xy${ firstLoginToBundles ? ' extra-margin-top' : '' }` }>
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <h4 className="h4">Your Basket</h4>
                            </div>
                        </div>
                        <iframe
                            className="payment_iframe"
                            ref="payment_iframe"
                            width="100%"
                            height="500px"
                            src={ paymentUrl } />
                    </div>
                </div>
            </div>
        );
    };
}

const mapStateToProps = state => {
    return {
        paymentUrl: state.transactions.basket.url,
        firstLoginToBundles: state.authentication.firstLoginToBundles,
    };
};

export default connect( mapStateToProps, null )( PaymentPage );



// WEBPACK FOOTER //
// src/client/components/site/pages/PaymentPage.js